import React, { memo } from 'react';
import KitschPopup from '../../components/UI/KitschPopup';

const FriendAddPopup = memo(({
    showPopup,
    userData,
    receiverNickname,
    onReceiverNicknameChange,
    onClose,
    onAddFriend
}) => {
    return (
        <KitschPopup
            visible={showPopup}
            title={'내 동물농장에\n코드 입력해 친구 추가하기'}
            secondaryButtonTitle="닫기"
            primaryButtonTitle="친구 추가하기"
            onSecondary={onClose}
            onPrimary={onAddFriend}
            onClose={onClose}
        >
            <div style={{ marginBottom: '24px' }}>
                <input
                    value={receiverNickname}
                    onChange={onReceiverNicknameChange}
                    placeholder='추가할 친구의 코드'
                    style={{
                        border: 'none',
                        borderBottom: '2px solid #FF7051',
                        outline: 'none',
                        padding: '8px 0',
                        fontSize: '15px',
                        fontWeight: '500',
                        color: '#000000',
                        fontFamily: 'Pretendard',
                        width: '100%',
                        boxSizing: 'border-box',
                        letterSpacing: '-0.3px',
                        backgroundColor: 'transparent',
                    }}
                />

                {userData?.user_nickname && (
                    <p style={{
                        fontSize: '15px',
                        fontFamily: 'Pretendard',
                        fontWeight: '500',
                        color: '#666666',
                        letterSpacing: '-0.3px',
                        lineHeight: '22px',
                        marginTop: '12px',
                        marginBottom: 0,
                    }}>
                        내 코드: {userData.user_nickname}
                    </p>
                )}
            </div>
        </KitschPopup>
    );
});

export default FriendAddPopup;
